import {Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

type IDropdownOption = any;

@Component({
    selector: 'ui-dropdown-simple',
    templateUrl: './dropdown-simple.component.html',
    styleUrls: ['./dropdown-simple.component.less']
})
export class DropdownSimpleComponent implements OnInit, OnChanges {

    constructor(private elementRef: ElementRef) { }

    @Input() keyName = 'key';
    @Input() valueName = 'value';
    @Input() selectedValue?: string|number = null;
    @Input() optionsList: Array<IDropdownOption> = [];
    @Input() showListOnTop = false;
    @Input() placeholder: string;
    @Input() disabled = false;
    @Output() valueChange: EventEmitter<IDropdownOption>  = new EventEmitter<IDropdownOption>();

    isOpened = false;

    @HostListener('document:click', ['$event.target'])
    clickOutside(target: HTMLElement): void {
        const clickedInside: boolean = this.elementRef.nativeElement.contains(target);
        if (!clickedInside && this.isOpened) {
            this.close();
        }
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const value = changes?.optionsList?.currentValue;
        if (Array.isArray(value)) {
            this.processOptionsList(value || []);
        }
    }

    private processOptionsList(optionsList: Array<any>): void {
        if (Array.isArray(optionsList)) {
            const OptionsList: IDropdownOption[] = optionsList // todo: investigate - needs correct deep cloning implementation (@Anton)
                .map((option: IDropdownOption) => {
                    if (typeof option === 'string' || typeof option === 'number') {
                        return { [this.keyName]: option, [this.valueName]: option };
                    } else {
                        return JSON.parse(JSON.stringify(option));
                    }
                });

            this.optionsList = OptionsList;
        } else {
            this.optionsList = [];
        }

    }

    toggleDropdown(): void {
        this.isOpened = !this.isOpened;
    }

    open(): void {
        this.isOpened = true;
    }

    close(): void {
        this.isOpened = false;
    }

    selectPageSize(selectedOption: IDropdownOption): void {
        if (this.selectedValue !== selectedOption[this.keyName]) {
            this.selectedValue = selectedOption[this.keyName];
            this.valueChange.emit(this.selectedValue);
        }
        this.close();
    }

}
